export const environment = {
  production: false,
  supabaseUrl: 'https://fcjyrnqmuzmoleetvzdw.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZjanlybnFtdXptb2xlZXR2emR3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0NTU3MTQsImV4cCI6MjA4OTAzMTcxNH0.ch4rzezwm6jDibBT4icrE3MKEmBP93R8L_1vOYubCqI',
  apiUrl: 'https://test.pxlvd.com/api',
};